import { Partner } from 'types';

export const getPartner = (partnerId: string, partners: Partner[]) =>
  partners?.find((partner: Partner) => partner?._id === partnerId);
